import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import PriceFormatter from './formatterComponents/PriceFormatter';
import MinimumPriceFormatter from './formatterComponents/MinimumPriceFormatter';
import Tooltip from './Tooltip';
import translator from '../translations/drupalTranslator';
import {decodeEntities} from '../api/utils';
import RadioButtonInput from './formComponents/RadioButtonInput';
import Translate from './Translate';

// TODO If there will be more services like this, we need to redesign AS400 service structure.
class ExtraService extends Component {
  constructor(props) {
    super(props);
    this.handleResize = throttle(() => this.forceUpdate(),
      100);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize',
      this.handleResize,
      false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize',
      this.handleResize,
      false);
  }

  onChange(name, value) {
    const { inputChange, validateFinalCleaning } = this.props;
    const updatedValue = typeof value === 'boolean' ? (value ? 1 : 0) : value; // eslint-disable-line no-nested-ternary
    inputChange(name,
      updatedValue);
    // Clear error.
    validateFinalCleaning().then(validator => validator());
  };

  extraServiceTooltip(extraService) {
    return (
      <Tooltip link={extraService.link}>
          <span>
            {translator.translate('Before your departure, you will handle the cleaning of the holiday home')}
            {extraService.link ? ( ". " +
              translator.translate('Click here for more information')
            ) : ''}
          </span>
      </Tooltip>
    )
  }

  render() {
    const { extraService, selectedFinalCleaning, showError } = this.props;

    let price;
    if (extraService.unitPrice.amount !== 0) {
      price = (<PriceFormatter price={extraService.unitPrice} />);
    }
    const rootClasses = ['final-cleaning'];
    if (showError) {
      rootClasses.push(`${rootClasses[0]}--error`);
    }
    return (
      <>
        <ul className={rootClasses.join(' ')}>
          <ul className='service '>
            <li className="service__name">
              {translator.translate('No final cleaning')}
            </li>
            <li className="service__tooltip" key="service__tooltip">
              {extraService.description ? this.extraServiceTooltip(extraService) : null}
            </li>
            <li className="service__price" key="service__price">{translator.translate('Free')}</li>
            <li className="service__input">
              <div className="form-radio-services">
                <RadioButtonInput
                  autoComplete="off"
                  checked={selectedFinalCleaning === 0}
                  id="final-cleaning"
                  name={extraService.serviceId}
                  onChange={this.onChange}
                  value={false}
                />
                <label htmlFor="final-cleaning" />
              </div>
            </li>

          </ul>
          <ul className='service'>
            <li className="service__name">
                {decodeEntities(extraService.name)}
              {extraService.minimumPrice.amount ? (
                <MinimumPriceFormatter
                  price={extraService.minimumPrice}
                />
              ) : null}
            </li>
            <li className="service__tooltip" key="service__tooltip">
                {extraService.description ? (
                    <Tooltip>
                      <span>{decodeEntities(extraService.description)}</span>
                    </Tooltip>
                ) : null}
            </li>
            <li className="service__price" key="service__price">{price}</li>
            <li className="service__input">
              <div className="form-radio-services">
                <RadioButtonInput
                  autoComplete="off"
                  checked={selectedFinalCleaning === 1}
                  id="final-cleaning-selected"
                  name={extraService.serviceId}
                  onChange={this.onChange}
                  value
                />
                <label htmlFor="final-cleaning-selected" />
              </div>
            </li>
          </ul>
          {showError ? (
            <ul className="error-list">
              <Translate component="li" content="Please select cleaning option" />
            </ul>
          ): null}
        </ul>
      </>
    );
  }
}

ExtraService.PropTypes = {
  extraService:PropTypes.shape({
    serviceId:PropTypes.string.isRequired,
    name:PropTypes.string.isRequired,
    type:PropTypes.string.isRequired,
    unitCount:PropTypes.number.isRequired,
    moreInfoLink:PropTypes.string,
    maxUnits:PropTypes.number.isRequired,
    obligatory:PropTypes.bool.isRequired,
    unitPrice:PropTypes.object.isRequired,
    minimumPrice:PropTypes.object.isRequired,
    paymentTime:PropTypes.string.isRequired,
    description:PropTypes.string.isRequired,
    unitDescription:PropTypes.string,
    selectedFinalCleaning:PropTypes.bool,
    showError:PropTypes.bool,
    validateFinalCleaning:PropTypes.func,
  }).isRequired,
  inputChange:PropTypes.func.isRequired,
};

export default ExtraService;
